import { render } from "./RoundedButton.vue?vue&type=template&id=281950c5&scoped=true"
import script from "./RoundedButton.vue?vue&type=script&lang=js"
export * from "./RoundedButton.vue?vue&type=script&lang=js"

import "./RoundedButton.vue?vue&type=style&index=0&id=281950c5&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Anael\\Documents\\developpement\\teachup-video-interactive\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-281950c5"]])

export default __exports__